import { Camera, Images, PlayCircle } from "lucide-react";
import { ManagedPageIntro } from "@/components/managed-page-intro";
import { PageHero } from "@/components/page-hero";
import { getPageCopy, getPublishedContent } from "@/lib/content-store";
import { toMedia, youtubeEmbedUrl } from "@/lib/content-view";

export const dynamic = "force-dynamic";

export default async function MediaPage() {
  const [copy, records] = await Promise.all([getPageCopy("media"), getPublishedContent("media")]);
  const collections = records.map(toMedia);
  return (
    <main>
      <PageHero eyebrow={copy.eyebrow} title={copy.title} description={copy.description} icon={Images} />
      <ManagedPageIntro body={copy.body} />
      <section className="mx-auto max-w-7xl px-6 py-16 sm:py-20">
        <div className="grid gap-6 lg:grid-cols-3">
          {collections.map((item) => {
            const Icon = item.mediaType === "video" ? PlayCircle : item.label.toLowerCase().includes("csapat") ? Images : Camera;
            const embedUrl = item.mediaType === "video" ? youtubeEmbedUrl(item.videoUrl) : null;
            return (
              <article key={item.id} className="group overflow-hidden rounded-[2rem] bg-[#102f53] text-white shadow-[0_24px_70px_-45px_rgba(16,47,83,.75)]">
                <div className="relative aspect-[4/3] overflow-hidden bg-[#0b2340]">
                  {item.mediaType === "image" && item.image && <img src={item.image} alt={item.alt} className="size-full object-cover transition duration-700 group-hover:scale-105" />}
                  {item.mediaType === "video" && embedUrl && <iframe src={embedUrl} title={item.alt || item.title} className="size-full" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />}
                  {item.mediaType === "video" && !embedUrl && item.videoUrl && <video controls preload="metadata" className="size-full object-cover"><source src={item.videoUrl} /></video>}
                  {!item.image && item.mediaType === "image" && <div className="flex size-full items-center justify-center"><Images className="size-16 text-white/30" /></div>}
                  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#102f53] via-transparent to-transparent" />
                  <div className="pointer-events-none absolute bottom-5 left-5 flex size-11 items-center justify-center rounded-full bg-[#ef233c]"><Icon className="size-5" aria-hidden="true" /></div>
                </div>
                <div className="p-7">
                  <p className="text-sm font-black uppercase tracking-[.18em] text-[#91baff]">{item.label || (item.mediaType === "video" ? "Videó" : "Fénykép")}</p>
                  <h2 className="mt-3 text-2xl font-black leading-tight">{item.title}</h2>
                  {item.caption && <p className="mt-3 text-sm leading-6 text-white/70">{item.caption}</p>}
                  {item.credit && <p className="mt-5 text-xs leading-5 text-white/55">Forrás: {item.source ? <a href={item.source} target="_blank" rel="noreferrer" className="underline decoration-white/25 underline-offset-2 hover:text-white">{item.credit}</a> : item.credit}{item.license && <> — {item.licenseUrl ? <a href={item.licenseUrl} target="_blank" rel="noreferrer" className="underline decoration-white/25 underline-offset-2 hover:text-white">{item.license}</a> : item.license}</>}</p>}
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </main>
  );
}
